<template>
    <header class="header">
      <div class="header-content">
        <div class="logo">
          <img src="@/assets/images/logo_header.png" alt="Logo" />
        </div>
        <nav class="header_icons_container">
          <div class="icon-wrapper" @click="homeClicked" title="Home">
            <img src="@/assets/images/home_icon_off.png" alt="Home" class="header_icon"/>
          </div>

          <div class="icon-wrapper" @click="usersClicked" title="Users">
            <img src="@/assets/images/users_icon_off.png" alt="Users" class="header_icon"/>
          </div>

          <div class="icon-wrapper" @click="plansClicked" title="Plans">
            <img src="@/assets/images/plans_icon_off.png" alt="Plans" class="header_icon"/>
          </div>

          <div class="icon-wrapper" @click="reservationsClicked" title="Reservations">
            <img src="@/assets/images/reservations_icon_off.png" alt="Reservations" class="header_icon"/>
          </div>

          <div class="icon-wrapper" @click="walletClicked" title="Wallet">
            <img src="@/assets/images/wallet_icon_off.png" alt="Wallet" class="header_icon"/>
          </div>

          <div class="icon-wrapper" @click="couponsClicked" title="Coupons">
            <img src="@/assets/images/coupons_icon_off.png" alt="Coupons" class="header_icon"/>
          </div>

          <div class="icon-wrapper" @click="invoicesClicked" title="Invoices">
            <img src="@/assets/images/invoices_icon_off.png" alt="Invoices" class="header_icon"/>
          </div>

          <div class="icon-wrapper logout-wrapper" @click="logoutClicked" title="Cerrar sesión">
            <img src="@/assets/images/logout_icon.png" alt="Cerrar sesión" class="header_icon"/>
          </div>
        </nav>
      </div>
    </header>
    <TwoButtonPopup 
      :title="twoButtonTitle"
      :message="twoButtonMessage"
      :acceptButton="twoButtonAcceptButton"
      @acceptCallback="logoutConfirmed"
      :cancelButton="twoButtonCancelButton"
      @cancelCallback="twoButtonCancelCallback"
      />
  </template>
  
  <script setup>
  import { ref } from "vue";
  import { useRouter } from 'vue-router';
  import TwoButtonPopup from './TwoButtonPopup.vue';
  
  const router = useRouter();
 
  const twoButtonTitle = ref("");
  const twoButtonMessage = ref("");
  const twoButtonAcceptButton = ref("");
  const twoButtonCancelButton = ref("");
  const loading = ref(false);

  const homeClicked = () => {
    router.push('/home');
  };

  const invoicesClicked = () => {
    router.push('/invoices');
  };

  const walletClicked = () => {
    router.push('/wallet');
  };

  const couponsClicked = () => {
    router.push('/coupons');
  };

  const reservationsClicked = () => {
    router.push('/reservations');
  }

  const plansClicked = () => {
    router.push('/plans');
  };

  const usersClicked = () => {
    router.push('/users');
  };

  const logoutClicked = () => {
    twoButtonTitle.value = "Cerrar sesión";
    twoButtonMessage.value = "¿Estás seguro de que deseas cerrar sesión?";
    twoButtonAcceptButton.value = "Cerrar sesión";
    twoButtonCancelButton.value = "Cancelar";
  };

  const logoutConfirmed = async () => {
    twoButtonTitle.value = "";
    loading.value = true;
    try {
      const response = await fetch(process.env.VUE_APP_API_URL+"api/dashboard/auth/logout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token'),
        },
        body: JSON.stringify({
          "user_id": localStorage.getItem('user_id')
        }),
      });

      await response.json();

    } catch (exception) {
      // do nothing
    } finally {
      loading.value = false;
      localStorage.removeItem('user_id');
      localStorage.removeItem('token');
      router.push('/');
    }
  };

  const twoButtonCancelCallback = () => {
    twoButtonTitle.value = "";
    twoButtonMessage.value = "";
  };

</script>
  
<style scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 20px;
    background-color: var(--gray);
    color: white;
    margin: 0;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 70px;
    z-index: 999;
    box-shadow: var(--shadow-md);
  }

  /* Removed .header-content wrapper styling to match original direct child layout if possible, 
     but since I introduced the wrapper in the template, I need to make the wrapper behave like the original header container */
  .header-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .logo {
    display: flex;
    align-items: center;
    cursor: pointer;
    width: 600px;
    max-width: 50%;
    margin-right: 30px;
}
  
  .logo img {
    width: 100%;
    max-width: 400px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .header_icons_container {
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
  }

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform var(--transition-fast);
  }

  .icon-wrapper:hover {
    transform: translateY(-2px);
  }

  .header_icon {
    height: 30px;
    display: flex;
    align-items: center;
  }

  .logout-wrapper {
      margin-left: 40px; /* Original margin-right was on the icon, moving spacing here */
  }

@media screen and (max-width: 768px) {
  .header {
    flex-direction: column;
    align-items: center;
    height: auto; /* Allow height to grow with content */
    min-height: 100px; /* Minimum height */
    padding: 15px 20px; /* Adjusted padding */
  }

  .header-content {
      flex-direction: column;
      align-items: center;
      gap: 15px; /* Add gap between logo and icons */
  }

  .logo {
      width: auto;
      max-width: 80%;
      margin-right: 0;
      justify-content: center;
  }

  .header_icons_container {
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 0; /* Remove top margin as gap handles it */
    gap: 15px; /* Increase gap for better touch targets */
    height: auto; /* Allow container to grow */
  }

  .logout-wrapper {
      margin-left: 0; /* Reset margin */
      margin-top: 5px; /* Add some separation if it wraps to new line */
  }
}

</style>
  